import { apiFetch, readJson } from './client';
import type {
  DirectorySyncStatus,
  DirectoryUser,
  DirectoryUsersLoadRequest
} from '@jarvis/platform-ui';

export type { DirectoryUser, DirectorySyncStatus, DirectoryUsersLoadRequest };

export interface DirectoryUserListPage {
  total: number;
  items: DirectoryUser[];
}

function toQueryString(params: Record<string, string | number | boolean | undefined>): string {
  const parts = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== '')
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`);
  return parts.length === 0 ? '' : `?${parts.join('&')}`;
}

export async function listCompanyEmployees(
  opts: DirectoryUsersLoadRequest = {}
): Promise<DirectoryUserListPage> {
  const res = await apiFetch(
    `/api/hr/company-employees${toQueryString(opts as Record<string, string | number | boolean | undefined>)}`
  );
  if (!res.ok) throw new Error(`Failed to list company employees: ${res.status}`);
  return readJson<DirectoryUserListPage>(res);
}

export async function fetchCompanyEmployeesSyncStatus(): Promise<DirectorySyncStatus> {
  const res = await apiFetch('/api/hr/company-employees/sync-status');
  if (!res.ok) throw new Error(`Failed to load sync status: ${res.status}`);
  return readJson<DirectorySyncStatus>(res);
}

export async function listCeClientAccessUsers(
  opts: DirectoryUsersLoadRequest = {}
): Promise<DirectoryUserListPage> {
  const res = await apiFetch(
    `/api/sales/ce-client-access${toQueryString(opts as Record<string, string | number | boolean | undefined>)}`
  );
  if (!res.ok) throw new Error(`Failed to list CE client access users: ${res.status}`);
  return readJson<DirectoryUserListPage>(res);
}

export async function fetchCeClientAccessSyncStatus(): Promise<DirectorySyncStatus> {
  const res = await apiFetch('/api/sales/ce-client-access/sync-status');
  if (!res.ok) throw new Error(`Failed to load sync status: ${res.status}`);
  return readJson<DirectorySyncStatus>(res);
}
